const CreateButton = (props: {value: string, extra?: string, onClick?: any, disabled?: boolean}) => {
	const {value, extra, onClick, disabled} = props;
    return (
        <button className={`linear flex items-center justify-center rounded-xl bg-[#0260CB] px-4 py-3 text-base font-medium text-white hover:bg-[#01499b] active:bg-[#024086] disabled:opacity-50 disabled:cursor-not-allowed ${extra}`}
		onClick={onClick}
		disabled={disabled}>
            {value}
        </button>
    );
};

export default CreateButton;